import { gql } from 'app/graphql';

export const GET_COUNTRY_PHONE_INFO = gql(`
    query GetCountryPhoneInfo {
        supportedCountries {
            codeName
            dialCode
            examplePhoneNumber
            name
        }
    }
`);